import { render, staticRenderFns } from "./ChecklistReportBoxV2.vue?vue&type=template&id=6e268c04"
import script from "./ChecklistReportBoxV2.vue?vue&type=script&lang=js"
export * from "./ChecklistReportBoxV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports